
<template>
<v-container>
  <v-layout row>
    <v-flex xs12>
      <v-card class="elevation-11">
        <v-card-text>
          <v-container>
            <h2 class="mb-4">New Greeting</h2>
            <form @submit.prevent="addGreeting()">

              <v-text-field
                name="title"
                label="Title"
                id="title"
                type="text"
                v-model.trim="title"
                required>
              </v-text-field>

              <v-textarea
                box
                name="description"
                label="Greeting text"
                id="description"
                v-model.trim="description"
                required>
              </v-textarea>

              <v-menu
                ref="menu"
                lazy
                :close-on-content-click="false"
                v-model="menu"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                min-width="290px"
                :return-value.sync="dateStart"
              >
                <v-text-field
                  slot="activator"
                  label="Start date*"
                  v-model="dateStart"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="dateStart" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.menu.save(dateStart)">OK</v-btn>
                </v-date-picker>
              </v-menu>

              <v-menu
                ref="menu2"
                lazy
                :close-on-content-click="false"
                v-model="menu2"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                min-width="290px"
                :return-value.sync="dateEnd"
              >
                <v-text-field
                  slot="activator"
                  label="End date*"
                  v-model="dateEnd"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="dateEnd" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.menu2.save(dateEnd)">OK</v-btn>
                </v-date-picker>
              </v-menu>

              <v-select
                label="Viewable By"
                class="mb-4"
                dense
                v-model="vb"
                :items="vbs"
                required
              ></v-select>

              <v-layout row class="mt-5">
                <v-flex xs12>
                  <v-btn small type="submit" :disabled="!formIsValid" class="primary">Submit</v-btn>
                <v-btn small @click="$router.replace('/admin')" class="secondary ml-2">Cancel</v-btn>
                </v-flex>
              </v-layout>
            </form>

          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      menu2: false,
      title: "",
      description: "",
      dateStart: "",
      dateEnd: "",
      vb: "",
      students: this.$store.getters.getStudents,
      vbs: ["all", ...this.$store.getters.getStudentsNames]
    }
  },
  computed: {
    formIsValid() {
      return (
        this.dateStart !== "" &&
        this.title !== "" &&
        this.description !== "" &&
        this.dateEnd !== "" &&
        this.vb !== ""
      )
    }
  },
  methods: {
    addGreeting() {
      let strVB = ""
      if (this.vb !== "all") {
        let objStudent = el => el.name === this.vb
        let idx = this.students.findIndex(objStudent)
        strVB = this.students[idx].userId
      } else {
        strVB = "all"
      }

      const newGreeting = {
        title: this.title,
        description: this.description,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        viewableBy: strVB,
        type: "greetings"
      }
      this.$store.dispatch("setType", "Greetings")
      this.$store.commit("setLoc", "viewItems")
      this.$store.dispatch("addGreeting", newGreeting)
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0px;
}

.v-textarea {
  font-size: .95em;
}

h2{
  font-size: 1.5rem;
}
</style>